module.exports = __webpack_public_path__ + "img/digital-marketing.46aec2f8.png";